import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import styled from 'styled-components';

export const SourcesAndUsesWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-auto-rows: auto;
	gap: 1rem;
	min-height: 0;
`;

export const SourcesUsesTableWrapper = styled.div<{ disabled?: boolean; hasError?: boolean }>`
	border-radius: 0.25rem;
	border: 1px solid
		${({ theme, hasError }) => (hasError ? theme.v3.colors.red[4] : theme.v3.colors.gray[4])};
	opacity: ${({ disabled = false }) => (disabled ? 0.2 : 1)};
	pointer-events: ${({ disabled = false }) => (disabled ? 'none' : 'auto')};
	display: flex;
	flex-direction: column;
	overflow: hidden;
	min-height: 0;
	height: 100%;

	> *:last-child {
		flex: 1;
		min-height: 0;
	}
`;

export const SourcesUsesTableHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.5rem;
	height: 3rem;
	border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
`;

export const SourcesUsesHeader = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-auto-rows: auto;
	gap: 1rem;
	padding: 0.5rem 0;
	background-color: ${({ theme }) => theme.v2.color.neutral[200]};
	border: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	border-radius: 0.25rem;
`;

export const SourcesUsesHeaderItem = styled.div`
	flex-grow: 1;
	display: grid;
	grid-template-columns: 40% 25% 25% 10%;
`;

export const SourcesUsesHeaderText = styled(TextV2)`
	color: ${({ theme }) => theme.color.greys[500]};
`;

export const SourcesUsesFooter = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-auto-rows: auto;
	gap: 1rem;
	padding: 0.5rem 0;
	background-color: ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.25rem;
`;

export const SourcesUsesFooterItem = styled.div`
	flex-grow: 1;
	display: grid;
	grid-template-columns: 40% 25% 25% 10%;
`;

export const PadLeft = styled.div`
	padding-left: 0.5rem;
`;
